import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';

/** The swap dialogs' buttons: pick one team, pick the other, confirm. */
export function SwapStepsFooter({
  step,
  canSwap,
  isSubmitting,
  nextDisabled,
  confirmDisabled = false,
  onCancel,
  onBack,
  onNext,
  onConfirm,
}: {
  step: 1 | 2 | 3;
  canSwap: boolean;
  isSubmitting: boolean;
  /** Steps 1 and 2: the team for that step isn't picked yet. */
  nextDisabled: boolean;
  confirmDisabled?: boolean;
  onCancel: () => void;
  onBack: () => void;
  onNext: () => void;
  onConfirm: () => void;
}) {
  return (
    <DialogFooter className="flex-col gap-2 sm:flex-row sm:justify-between sm:gap-0">
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        disabled={isSubmitting}
      >
        Cancelar
      </Button>

      {canSwap && step === 1 && (
        <Button type="button" onClick={onNext} disabled={nextDisabled}>
          Continuar
        </Button>
      )}

      {canSwap && step !== 1 && (
        <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row">
          <Button
            type="button"
            variant="outline"
            onClick={onBack}
            disabled={isSubmitting}
          >
            Atrás
          </Button>
          {step === 2 ? (
            <Button type="button" onClick={onNext} disabled={nextDisabled}>
              Continuar
            </Button>
          ) : (
            <Button
              type="button"
              onClick={onConfirm}
              disabled={isSubmitting || confirmDisabled}
            >
              {isSubmitting ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Intercambiando…
                </>
              ) : (
                'Confirmar intercambio'
              )}
            </Button>
          )}
        </div>
      )}
    </DialogFooter>
  );
}
